import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import EquipmentService from "../app/data/equipment/equipmentServices";

const equipmentService = EquipmentService.getInstance();


export const useEquipmentTypes = () => {
  return useQuery({
    queryKey: ["GET_EQUIPMENT_TYPES"],
    queryFn: () => equipmentService.getEquipmentTypes(),
    select: (res) => {
      return (res?.data || []).map((item: string) => ({
        label: item,
        value: item,
      }));
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useEquipmentList = (
  search?: string,
  type?: string,
  status?: string
) => {
  return useInfiniteQuery({
    queryKey: ["GET_EQUIPMENT_LIST", search, type, status],
    queryFn: ({ pageParam = 0 }) =>
      equipmentService.getequipmentList(search, pageParam, type, status),

    getNextPageParam: (lastPage) => {
      const currentPage = lastPage?.data?.number ?? 0;
      const totalPages = lastPage?.data?.totalPages ?? 0;
      return currentPage + 1 < totalPages ? currentPage + 1 : undefined;
    },

    select: (data) => {
      const allItems = data.pages.flatMap((p) => p.data.content);
      return { ...data, allItems };
    },

    staleTime: 1000 * 60 * 5,
  });
};


export const useEquipmentListDetails = (equipmentNumber: string) => {
  return useQuery({
    queryKey: ["GET_EQUIPMENT_DETAIL", equipmentNumber],
    queryFn: () => equipmentService.getEquipmentDetails(equipmentNumber),
    enabled: !!equipmentNumber,
    staleTime: 1000 * 60 * 5,
  });
};

// CREATE
export const useCreateEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => EquipmentService.getInstance().createEquipment(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GET_EQUIPMENT_LIST"] });
      },
      onError: (error: any) => {
        throw new Error(error.message);
      }
    }
  );
};

// UPDATE
export const useUpdateEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, payload }: any) => EquipmentService.getInstance().updateEquipment(id, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GET_EQUIPMENT_LIST"] });
      },
      onError: (error: any) => {
        throw new Error(error.message);
      }
    }
  );
};

// DELETE
export const useDeleteEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => equipmentService.deleteEquipment(id),

    onSuccess: () => {
      queryClient.invalidateQueries(["GET_EQUIPMENT_LIST"]);
    },
  });
};

// DOWNLOAD CSV
export const useDownloadCSVEquipment = () => {
  return useMutation({
    mutationFn: (search: string) => equipmentService.getDownloadCSVEquipment(search),
  });
};
